import Vue from 'vue'
import Vuex from 'vuex'
import menu from './modules/menu'
import base from './modules/base'
import auth from './modules/auth'
import app from './modules/app'
import invoicesIssued from './modules/invoicesIssued'
import invoicesReceived from './modules/invoicesReceived'
import invoicesIssuing from './modules/invoicesIssuing/invoicesIssuing'
import verifactu from './modules/verifactu'
import companies from './modules/companies'
import companiespge from './modules/companiespge'
import certificates from './modules/certificates'
import certcompanies from './modules/certcompanies'
import configurations from './modules/configurations'
import companyprovideruser from './modules/companyprovideruser'
import userstatus from './modules/userstatus'
import users from './modules/users'
import userscompanies from './modules/userscompanies'
import groups from './modules/groups'
import groupusers from './modules/groupusers'
import groupstatus from './modules/groupstatus'
import groupcompanies from './modules/groupcompanies'
import invoicegroups from './modules/invoicegroups'
import usergroups from './modules/usergroups'
import uploaderrors from './modules/uploaderrors'

import rules from './modules/rules'
import rulegroups from './modules/rulegroups'
import grouprules from './modules/grouprules'

import imports from './modules/imports'

import clients from './modules/clients'
import webhooks from './modules/webhooks'
import sociedades from './modules/sociedades'
import sedes from './modules/sedes'
import contactemails from './modules/contactemails'
import bankaccounts from './modules/bankAccounts'
import linkedCompanies from './modules/linkedCompanies'
import administrativecenters from './modules/administrativecenters'
import userprovidercontact from './modules/userprovidercontact'
import administrativecentersfb2b from './modules/administrativecentersfb2b'

import products from './modules/products'
import productsImpuestos from './modules/productsImpuestos'

import impuestos from './modules/impuestos'

import distributors from './modules/distributors'

import groupingcompanies from './modules/groupingcompanies'
import groupingbuyers from './modules/groupingbuyers'
import groupingsellers from './modules/groupingsellers'

import historicalCert from './modules/historicalCert'
import historicalUser from './modules/historicalUser'
import historicalGroup from './modules/historicalGroup'
import historicalRule from './modules/historicalRule'
import historicalClient from './modules/historicalClient'
import historicalWebhook from './modules/historicalWebhook'
import historicalDistributor from './modules/historicalDistributor'
import historicalInvoice from './modules/historicalInvoice'
import historicalVerifactu from './modules/historicalVerifactu'
import historicalCompany from './modules/historicalCompany'
import historicalContact from './modules/historicalContact'
import historicalImpuestos from './modules/historicalImpuestos'
import historicalProducts from './modules/historicalProducts'

import trashCertificates from './trashmodules/certificates'
import trashClients from './trashmodules/clients'
import trashCompanies from './trashmodules/companies'
import trashInvoicesIssued from './trashmodules/invoicesIssued'
import trashInvoicesReceived from './trashmodules/invoicesReceived'
import trashVerifactu from './trashmodules/verifactu'
import trashUsers from './trashmodules/users'
import trashGroups from './trashmodules/groups'
import trashSociedades from './trashmodules/sociedades'
import trashImpuestos from './trashmodules/impuestos'
import trashProducts from './trashmodules/products'
import trashHistoricalCertificates from './trashmodules/historicalCert'
import trashHistoricalClients from './trashmodules/historicalClient'
import trashHistoricalCompanies from './trashmodules/historicalCompany'
import trashHistoricalInvoices from './trashmodules/historicalInvoice'
import trashHistoricalVerifactu from './trashmodules/historicalVerifactu'
import trashHistoricalUsers from './trashmodules/historicalUser'
import trashHistoricalContacts from './trashmodules/historicalContacts'
import trashHistoricalGroups from './trashmodules/historicalGroups'
import trashHistoricalImpuestos from './trashmodules/historicalImpuestos'
import trashHistoricalProducts from './trashmodules/historicalProducts'

import navigation from './modules/navigation'

import config from './config'

import dashboard from './modules/dashboard'

import aadAuth from './modules/aadAuth'

import removeStoreProperties from '@/services/functions/removeStoreProperties'

import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

const authState = createPersistedState({
  paths: ['auth', 'app', 'base', 'menu'],
  rehydrated: rehydrated
})

const sesionState = createPersistedState({
  paths: ['navigation'],
  storage: window.sessionStorage,
  rehydrated: rehydrated
})

const stp = (store) => {
  store.subscribe((mutation, state) => {
    switch (mutation.type) {
      case 'app/setNavigationFromMenu':
        if (mutation.payload === true) {
          const _resetModules = ['base']
          _resetModules.forEach(element => {
            store.commit(element + '/setCurrentPage', 1)
            store.commit(element + '/resetMasterFilters')
            store.commit(element + '/resetPaginationInfo')
            if (element === 'communications') {
              store.commit(element + '/resetSelectedUserForCommunication')
            }
            state.app.navFromMenu = false
          })
        }
        break
    }
    removeStoreProperties()
  })
}

export default new Vuex.Store({
  state: {
    isLoading: false,
    headCoreReady: false,
    ajaxQueryPending: false,
    lastAjaxResult: ''
  },
  mutations: {
    setIsLoading (state, status) {
      state.isLoading = status
    },
    setHeadCoreStatus (state, status) {
      state.headCoreReady = status
    },
    setAjaxRequestPending (state, status) {
      state.ajaxQueryPending = status
    },
    setLastAjaxResult (state, status) {
      state.lastAjaxResult = status
    }
  },
  getters: {
    isLoading: state => state.isLoading,
    isHeadCoreReady: state => state.headCoreReady,
    isAjaxQueryPending: state => state.ajaxQueryPending,
    lastAjaxResult: state => state.lastAjaxResult
  },
  modules: {
    menu,
    base,
    invoicesIssued,
    invoicesReceived,
    invoicesIssuing,
    verifactu,
    companies,
    companiespge,
    certificates,
    certcompanies,
    configurations,
    companyprovideruser,
    users,
    groups,
    groupusers,
    groupcompanies,
    groupstatus,
    invoicegroups,
    usergroups,
    uploaderrors,
    userscompanies,
    userstatus,
    clients,
    webhooks,
    sociedades,
    contactemails,
    bankaccounts,
    linkedCompanies,
    userprovidercontact,
    impuestos,
    administrativecenters,
    administrativecentersfb2b,
    sedes,
    imports,
    rules,
    rulegroups,
    grouprules,
    historicalRule,
    distributors,
    groupingcompanies,
    groupingbuyers,
    groupingsellers,
    historicalCert,
    historicalUser,
    historicalContact,
    historicalGroup,
    historicalClient,
    historicalWebhook,
    historicalDistributor,
    historicalInvoice,
    historicalVerifactu,
    historicalCompany,
    historicalImpuestos,
    trashCertificates,
    trashClients,
    trashCompanies,
    trashInvoicesIssued,
    trashInvoicesReceived,
    trashVerifactu,
    trashUsers,
    trashGroups,
    trashSociedades,
    trashImpuestos,
    trashHistoricalUsers,
    trashHistoricalContacts,
    trashHistoricalGroups,
    trashHistoricalCertificates,
    trashHistoricalClients,
    trashHistoricalCompanies,
    trashHistoricalInvoices,
    trashHistoricalVerifactu,
    trashHistoricalImpuestos,
    auth,
    app,
    aadAuth,
    dashboard,
    products,
    productsImpuestos,
    historicalProducts,
    trashProducts,
    trashHistoricalProducts,
    navigation,
    config,
  },
  plugins: [authState, sesionState, stp]
})

function rehydrated ({ getters }) {
  const darkMode = getters['app/darkMode']
  if (darkMode === false) {
    document.body.classList.remove('dark')
  } else {
    document.body.classList.add('dark')
  }
}
